import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { Banner } from "../../../ui/organisms/banner"
import { formatterDate, IVModeOptions, IVTypeOptions, optionsFormatter } from "../../../utils"
import { EditIcon } from "../../../ui/icons/edit"
import { useEffect } from "react"
import { GetAllPacDetails, setPACDetailClient, setPACDetailIdToUpdate, setPACDetailNorm, setPACDetailsUpdateNote, setPACDetailUpdateAnnualControlPlaneId, setPACDetailUpdateMode, setPACDetailUpdatePeriodicity, setPACDetailUpdateSampling, setPACDetailUpdateSpecifications, setPACDetailUpdateVisitingType } from "./slice"
import { handlePeriodicity } from "./utils"
import { PACDetailDTO } from "./dataService/dto"

export function PACCustomerList() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const sessionState = useAppSelector(state => state.session)
    const pacState = useAppSelector(state => state.pac)
    const pacDetails = pacState.getAllPACDetailsResponse?.data ?? []

    useEffect(() => {
        dispatch(GetAllPacDetails({ itemsPerPage: 0, page: 0, customerId: sessionState.selected.customerId!, order: true }))
    }, [])

    const onEditHandle = (pacDetail: PACDetailDTO) => {
        dispatch(setPACDetailIdToUpdate(pacDetail.id))
        dispatch(setPACDetailUpdateAnnualControlPlaneId(pacDetail.annualControlPlaneDTO.id))
        dispatch(setPACDetailNorm(pacDetail.annualControlPlaneDTO.norm))
        dispatch(setPACDetailClient(sessionState.selected.customerName))
        dispatch(setPACDetailUpdatePeriodicity(pacDetail.periodicity))
        dispatch(setPACDetailUpdateMode(pacDetail.mode))
        dispatch(setPACDetailUpdateVisitingType(pacDetail.visitType))
        dispatch(setPACDetailUpdateSampling(pacDetail.sampling))
        dispatch(setPACDetailUpdateSpecifications(pacDetail.specifications))
        dispatch(setPACDetailsUpdateNote(pacDetail.note))
        navigate('/editPacDetail')
    }

    if (sessionState.selected.customerId) {
        return (
            <div className="p-6">
                <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                    <table className="w-full border-collapse text-sm">
                        <thead>
                            <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl"></th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Anno</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Periodo</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Modalita visita</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Tipo Visita</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Specifiche</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Prelievo</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Valido dal</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Valido al</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Riferimento incarico</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data visita</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Note</th>
                                <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[60px]"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {pacDetails.length === 0 ? (
                                <tr>
                                    <td colSpan={13} className="px-3 py-4 text-center text-neutral-500 bg-white">
                                        Nessun pac trovato
                                    </td>
                                </tr>
                            ) : (
                                pacDetails.map((pac, index) => (
                                    <tr
                                        key={pac.id ?? index}
                                        className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                    >
                                        <td className="px-3 py-2">
                                            <div className="flex items-center gap-2">
                                                <button
                                                    className="relative group p-1 rounded hover:bg-neutral-100 transition-colors"
                                                    onClick={() => onEditHandle(pac)}
                                                >
                                                    <EditIcon color="orange" size={20} />
                                                    <span className="absolute bottom-full right-0 mb-1 hidden group-hover:block px-2 py-1 text-xs text-white bg-neutral-800 rounded whitespace-nowrap pointer-events-none z-10">
                                                        Modifica PAC
                                                    </span>
                                                </button>
                                            </div>
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {pac.annualControlPlaneDTO.year}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {handlePeriodicity(pac.periodicity)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {optionsFormatter(pac.mode, IVModeOptions)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {optionsFormatter(pac.visitType, IVTypeOptions)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {pac.specifications}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {pac.sampling ? 'Sì' : 'No'}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap text-xs">
                                            {formatterDate(pac.annualControlPlaneDTO.startingDate)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap text-xs">
                                            {formatterDate(pac.annualControlPlaneDTO.endingDate)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            DA IMPL.
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            DA IMPL.
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {pac.note}
                                        </td>
                                        <td className="px-3 py-2"></td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    return (
        <Banner
            type="error"
            visible={!sessionState.selected.customerId}
            label={"Devi prima selezionare un cliente per accedere all'area"}
            closeAction={function (): void {
                alert("Devi prima selezionare un cliente per accedere all'area")
            }}
        />
    )
}